import { FC } from 'react';

import { IconContainer } from '../IconContainer';
import { IconProps } from '../types';

export const IconArrowRightCorner24: FC<IconProps> = ({
  size = 24,
  color = 'currentColor',
  className,
  style,
  svgClassName,
  svgStyle,
  ariaLabel,
  onClick,
}) => {
  return (
    <IconContainer
      size={size}
      className={className}
      style={style}
      ariaLabel={ariaLabel}
      onClick={onClick}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={svgClassName}
        style={svgStyle}
      >
        <path d="M8.66292 7.38281C8.24879 7.38281 7.91307 7.71853 7.91307 8.13267C7.91307 8.54683 8.24883 8.88256 8.66298 8.88253L14.5873 8.88206L7.91299 15.5573C7.62013 15.8502 7.62015 16.3251 7.91303 16.6179C8.20594 16.9108 8.68084 16.9108 8.97373 16.6179L15.649 9.94166L15.6485 15.8681C15.6485 16.2822 15.9842 16.618 16.3984 16.618C16.8125 16.618 17.1482 16.2823 17.1482 15.8681L17.1482 7.38281L8.66292 7.38281Z" fill={color}/>
      </svg>
    </IconContainer>
  );
};
